<template>
    <div>
        <b-modal :id="my_modal" size="xl" scrollable class="modal" hide-header hide-footer>
            <div class="job-info" v-if="load">
                <div class="row main-row" >
                    <div class="col-lg-6 col-md-12">
                        <h4 class="job-disc">{{ $t('job_form.job_description') }}</h4>
                        <div class="line">
                        </div>
                        <ul class="ul-disc" style="padding-left: 0px">
                            <!-- <li class="row" v-for="(item, index) in Job_description" :key="index">
                                <b-icon icon="check-lg"></b-icon> -->
                                <p v-html="Job_description"></p>
                            <!-- </li> -->
                        </ul>
                    </div>
                    <div class="col-lg-6 col-md-12 left">
                        <h4 class="job-req">{{ $t('job_form.job_requirements') }}</h4>
                        <div class="line">
                        </div>
                        <ul class="ul-req" style="padding-left: 0px">
                            <!-- <li class="row" v-for="(item, index) in Job_requirements" :key="index">
                                <b-icon icon="check-lg"></b-icon> -->
                                <p v-html="Job_requirements"></p>
                            <!-- </li> -->
                        </ul>
                    </div>
                </div>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center">
                <b-spinner style="width: 3rem; height: 3rem;color:var(--main-blue);margin-top: 80px"  label="Loading..."></b-spinner>
            </div>
        </b-modal>
        <!-- <b-modal :id="my_modal" size="md" scrollable class="modal" ok-only v-else>
            <b-spinner label="Loading..."></b-spinner>
        </b-modal > -->
    </div>
</template>

<script>
import MyButton2 from "@/components/MyButton2.vue"
export default {
    name: "ModalDetailsPosition",
    props: ['my_modal', 'my_id'],
    components: {
        MyButton2
    },
    data() {
        return {
            data: [],
            Job_description: "",
            Job_requirements: "",
            status: false,
            load: false
        };
    },
    methods: {
        getData() {
            this.lang = localStorage.getItem('lang')
            this.axios.get(this.$store.state.url + "jobs/" + this.my_id)
                .then(res => {
                    this.load = true
                    console.log(res.data)
                    this.Job_description = res.data.list.Job_details
                    this.Job_requirements = res.data.list.Job_requirement
                    if (res.data.error == 'true')
                        this.status = false
                    else
                        this.status = true
                });
        },
    },
    mounted() {
        this.getData()
    },
    created() {
        // console.log(this.my_id)
    }

};

</script>


<style lang="scss">
.modal {
    // margin: 50px 0px;
    top: 80px !important;
    height: 85% !important;
}
.modal-md .modal-body{
    text-align: center;
    font-size: 18px;
}
.modal-xl{
    min-height: 300px !important;
}
.modal .job-disc,
.modal .job-req {
    color: var(--main-blue);
}
.modal ul{
    list-style-type: disc !important;
}

html:lang(ar) .modal .job-disc,
html:lang(ar) .modal .job-req {
    text-align: right;
}

html:lang(en) .modal .job-disc,
html:lang(en) .modal .job-req {
    text-align: left;
}

.modal .line {
    border-bottom: 1px solid #bebebe;
    margin: 20px 0px;
}

.modal .bi-check-lg {
    color: var(--main-green);
    font-size: 15px;
    margin-top: 5px;
    margin-right: 10px;
}

.modal .ul-disc,
.modal .ul-req {
    margin-top: 20px;
}

.modal .ul-disc .row,
.modal .ul-req .row {
    flex-wrap: nowrap !important;
}

.modal-content {
    border-radius: 20px !important;
}

@media (min-width: 992px) {
    .modal .left {
        margin-left: 20px;
    }

    .modal .main-row {
        flex-wrap: nowrap;
    }

    .modal .modal-body {
        padding: 40px 50px;
    }
}

@media (max-width: 992px) {
    .modal .main-row {
        flex-wrap: wrap;
    }

    .modal .modal-body {
        padding: 35px;
    }
}

html:lang(en) .details-button {
    margin-left: 10px;
}

html:lang(ar) .details-button {
    margin-right: 10px;
}

.details-button {
    position: relative;
    color: var(--main-blue);
    font-size: 13px;
    text-decoration: none;
    margin: 30px 0 0;
    border: 1px solid var(--main-blue);
    padding: 6px 15px;
    overflow: hidden;
    transition: .6s all ease;
    background: #fff;
    border-radius: 10px;
    z-index: 100000;

}



.details-button::before {
    background: var(--main-blue);
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    transition: all .6s ease;
}

.details-button:hover {
    color: #fff;
    // font-weight: 800;
}

.details-button::before {
    width: 0%;
    height: 104%;
}

.details-button:hover::before {
    width: 102%;
}
</style>